import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PermissionEnum, TransactionLogsContent } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemNostroTransaction from '../hooks/use-nostro';

const ProblemNostroTransactionLogContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const { logs } = useAppSelector(
    (state) => state.customersProblemTransactions.nostro,
  );
  const { activePermissions } = useAppSelector((state) => state.root);

  const { getNostroLogsAction, logsIsLoading } = useProblemNostroTransaction({
    transactionId,
  });

  useEffect(() => {
    if (!logs && transactionId) {
      getNostroLogsAction();
    }
  }, [getNostroLogsAction, logs, transactionId]);

  return (
    <TransactionLogsContent
      isLoading={logsIsLoading}
      logs={logs}
      activePermission={activePermissions?.includes(
        PermissionEnum.TRANSACTION_QUEUE_ITEMS_NOSTRO_LIST,
      )}
    />
  );
};

export default ProblemNostroTransactionLogContentHOC;
